import { Controller } from "@hotwired/stimulus"

// Submits the enclosing form when a field changes.
// Usage: data-controller="auto-submit" data-action="change->auto-submit#submit"
// Typing fields: data-auto-submit-delay-value="300" data-action="input->auto-submit#submit" debounces the submit.
export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } }

  submit() {
    clearTimeout(this.timer)
    if (this.delayValue > 0) {
      this.timer = setTimeout(() => this.element.form.requestSubmit(), this.delayValue)
    } else {
      this.element.form.requestSubmit()
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
